// Heading atom component
export const Heading = ({ level = 1, children, className = "", ...props }) => {
  const baseStyles =
    "font-display font-semibold text-terracotta-800 tracking-tight";

  const sizes = {
    1: "text-5xl md:text-6xl leading-[1.05]",
    2: "text-4xl md:text-5xl leading-tight",
    3: "text-2xl md:text-3xl",
    4: "text-xl",
  };

  const HeadingTag = `h${level}`;

  return (
    <HeadingTag
      className={`${baseStyles} ${sizes[level]} ${className}`}
      {...props}
    >
      {children}
    </HeadingTag>
  );
};
